import { FiGithub, FiLinkedin, FiInstagram } from "react-icons/fi";
import "./LeftPanelStyle.css";

export default function LeftPanel() {
  return (
    <div className='left-panel-div'>
      <a
        href='https://www.linkedin.com/in/kanikarajpal/'
        target='_blank'
        rel='noreferrer'
        className='linkedin-icon all-icons'
      >
        <FiLinkedin size={20} color='white' />
      </a>
      <a href='https://github.com/kanikarajpal' target='_blank' rel='noreferrer' className='github-icon all-icons'>
        <FiGithub size={20} color='white' />
      </a>
      <a
        href='https://www.instagram.com/kanika_rajpal_02/'
        target='_blank'
        rel='noreferrer'
        className='instagram-icon all-icons'
      >
        <FiInstagram size={20} color='white' />
      </a>
      <div className='vertical-line '></div>
    </div>
  );
}
